export const copyText = str => {
  if (typeof document !== 'undefined') {
    const textField = document.createElement('textarea');
    textField.innerText = str;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
  }
};
